export const COMPANY = {
  name: "Alex Interiors",
  tagline: "Design • Build • Deliver",
  phones: ["+91 6291935280 (India)", "+91 9874339974 (India)", "+ 1 4155355838 (USA)"],
  whatsapp: "916291935280",
  emails: ["info@alexinteriors.co.in","projects@alexinteriors.co.in", "alexinteriorskol@gmail.com"],
  hq: {
    label: "Registered Office",
    address: "Ashray Villa, 3rd Floor, 2L Natore Park, 4th Road, Kolkata – 700039",
  },
  branch: {
    label: "Branch Office",
    address: "18/21, Fern Rd, Ballygunge Gardens, Gariahat, Kolkata, West Bengal 700019, India",
  },
  founded: 2012,
};

export const STATS = [
  { value: "14+", label: "Years in Business" },
  { value: "1000+", label: "Projects Delivered" },
  { value: "15+", label: "States Across India" },
  { value: "10+", label: "Marquee Brands" },
];

export const CLIENTS = [
  { name: "Wealth 360 One", logo: "https://logo.clearbit.com/360.one" },
  { name: "Bandhan Bank", logo: "https://logo.clearbit.com/bandhanbank.com" },
  { name: "Axis Bank", logo: "https://logo.clearbit.com/axisbank.com" },
  { name: "Karur Vysya Bank", logo: "https://logo.clearbit.com/kvb.co.in" },
  { name: "Kotak Life Insurance", logo: "https://logo.clearbit.com/kotaklife.com" },
  { name: "HDB Financial Services", logo: "https://logo.clearbit.com/hdbfs.com" },
  { name: "Aditya Birla Capital", logo: "https://logo.clearbit.com/adityabirlacapital.com" },
  { name: "Future Generali", logo: "https://logo.clearbit.com/futuregenerali.in" },
  { name: "Magma HDI", logo: "https://logo.clearbit.com/magmahdi.com" },
  { name: "AGEAS Federal", logo: "https://logo.clearbit.com/ageasfederal.com" },
  { name: "PNB MetLife", logo: "https://logo.clearbit.com/pnbmetlife.com" },
  { name: "Bharti Airtel", logo: "https://logo.clearbit.com/airtel.in" },
  { name: "Eureka Forbes", logo: "https://logo.clearbit.com/eurekaforbes.com" },
];

export const SERVICES = [
  {
    title: "Interior Designing",
    short: "Concept design, layouts and 3D visualisation aligned to your brand.",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1400&q=80",
  },
  {
    title: "Carpentry Works",
    short: "Custom millwork, joinery, counters and fixtures finished in-house.",
    image: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1400&q=80",
  },
  {
    title: "Civil Works",
    short: "Demolition, masonry, flooring, false ceiling and partitioning.",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1400&q=80",
  },
  {
    title: "Plumbing",
    short: "Sanitary, piping and pantry installations to commercial standards.",
    image: "https://images.unsplash.com/photo-1542013936693-884638332954?auto=format&fit=crop&w=1400&q=80",
  },
  {
    title: "Electrification",
    short: "Power layouts, panels, lighting and certified electrical execution.",
    image: "https://images.unsplash.com/photo-1558002038-1055907df827?auto=format&fit=crop&w=1400&q=80",
  },
  {
    title: "Networking",
    short: "Structured cabling, racks and LAN/WAN backbone for branch offices.",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=1400&q=80",
  },
  {
    title: "Air Conditioning",
    short: "HVAC sizing, ducting and installation for offices and branches.",
    image: "https://images.unsplash.com/photo-1718203862467-c33159fdc504?auto=format&fit=crop&w=1400&q=80",
  },
  {
    title: "CCTV & Fire Alarm",
    short: "Surveillance, access control, fire detection and life-safety systems.",
    image: "https://images.unsplash.com/photo-1586953208448-b95a79798f07?auto=format&fit=crop&w=1400&q=80",
  },
];

export const PROJECTS = [
  { id: "p22", client: "Wealth 360 One", title: "Wealth 360 One — Camac Street", category: "Financial Services", location: "Kolkata, WB", image: "https://images.unsplash.com/photo-1600607686527-6fb886090705?auto=format&fit=crop&w=1600&q=80" },
  { id: "p1", client: "Bandhan Bank", title: "Bandhan Bank — Kalyan Branch", category: "Banking", location: "Mumbai, MH", image: "https://images.unsplash.com/photo-1556742044-3c52d6e88c62?auto=format&fit=crop&w=1600&q=80" },
  { id: "p2", client: "Bandhan Bank", title: "Bandhan Bank — Barpeta Road", category: "Banking", location: "Assam", image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1600&q=80" },
  { id: "p3", client: "Bandhan Bank", title: "Bandhan Bank — Burra Bazaar (Renovation)", category: "Banking", location: "Kolkata, WB", image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1600&q=80" },
  { id: "p4", client: "Axis Bank", title: "Axis Bank — CRES Office", category: "Banking", location: "Kolkata, WB", image: "https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=1600&q=80" },
  { id: "p5", client: "Karur Vysya Bank", title: "Karur Vysya Bank — Berhampur Branch", category: "Banking", location: "Odisha", image: "https://images.unsplash.com/photo-1497215842964-222b430dc094?auto=format&fit=crop&w=1600&q=80" },
  { id: "p6", client: "Karur Vysya Bank", title: "Karur Vysya Bank — Cuttack Branch", category: "Banking", location: "Odisha", image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1600&q=80" },
  { id: "p7", client: "Kotak Life Insurance", title: "Kotak Life — Behala Chowrasta", category: "Insurance", location: "Kolkata, WB", image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1600&q=80" },
  { id: "p8", client: "HDB Financial Services", title: "HDB Financial — Jorhat", category: "Financial Services", location: "Assam", image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1600&q=80" },
  { id: "p9", client: "HDB Financial Services", title: "HDB Financial — Krishnanagar", category: "Financial Services", location: "West Bengal", image: "https://images.unsplash.com/photo-1505663912202-ac22d4cb3707?auto=format&fit=crop&w=1600&q=80" },
  { id: "p10", client: "Aditya Birla Capital", title: "Aditya Birla Capital — Bhilai", category: "Insurance", location: "Chhattisgarh", image: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1600&q=80" },
  { id: "p11", client: "Aditya Birla Capital", title: "Aditya Birla Capital — Jorhat", category: "Insurance", location: "Assam", image: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80" },
  { id: "p12", client: "Future Generali", title: "Future Generali — Gariahat", category: "Insurance", location: "Kolkata, WB", image: "https://images.unsplash.com/photo-1531973576160-7125cd663d86?auto=format&fit=crop&w=1600&q=80" },
  { id: "p13", client: "Future Generali", title: "Future Generali — Bhopal", category: "Insurance", location: "Madhya Pradesh", image: "https://images.unsplash.com/photo-1542744094-3a31f272c490?auto=format&fit=crop&w=1600&q=80" },
  { id: "p14", client: "Magma HDI", title: "Magma HDI — Regional Office", category: "Insurance", location: "Kolkata, WB", image: "https://images.unsplash.com/photo-1568992688065-536aad8a12f6?auto=format&fit=crop&w=1600&q=80" },
  { id: "p15", client: "Magma HDI", title: "Magma HDI — Pondicherry", category: "Insurance", location: "Puducherry", image: "https://images.unsplash.com/photo-1558002038-1055907df827?auto=format&fit=crop&w=1600&q=80" },
  { id: "p16", client: "AGEAS Federal", title: "AGEAS Federal — Trichy", category: "Insurance", location: "Tamil Nadu", image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1600&q=80" },
  { id: "p17", client: "AGEAS Federal", title: "AGEAS Federal — Mysore", category: "Insurance", location: "Karnataka", image: "https://images.unsplash.com/photo-1586953208448-b95a79798f07?auto=format&fit=crop&w=1600&q=80" },
  { id: "p18", client: "PNB MetLife", title: "PNB MetLife — Bhubaneswar", category: "Insurance", location: "Odisha", image: "https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?auto=format&fit=crop&w=1600&q=80" },
  { id: "p19", client: "PNB MetLife", title: "PNB MetLife — Bhadrak", category: "Insurance", location: "Odisha", image: "https://images.unsplash.com/photo-1497211419994-14ae40a3c7a3?auto=format&fit=crop&w=1600&q=80" },
  { id: "p20", client: "Bharti Airtel", title: "Airtel — Birati Store", category: "Telecom & Retail", location: "Kolkata, WB", image: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1600&q=80" },
  { id: "p21", client: "Bharti Airtel", title: "Airtel — James Long Sarani", category: "Telecom & Retail", location: "Kolkata, WB", image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1600&q=80" },
];

export const CATEGORIES = ["All", "Banking", "Insurance", "Financial Services", "Telecom & Retail"];

export const PROCESS = [
  { n: "01", t: "Inquiry & Survey", d: "Share your requirement. We visit the site, capture measurements and brand standards." },
  { n: "02", t: "Design & BOQ", d: "Layouts, 3D views and a transparent line-item Bill of Quantities for approval." },
  { n: "03", t: "Execution & Handover", d: "Civil, carpentry, MEP and finishing — delivered on schedule, snag-free." },
];
